import { Link } from "react-router-dom";
import "./Unauthorized.css";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const Unauthorized = () => {
  return (
    <div className="unauthorized-wrapper">
      <div className="unauthorized-card">
        
        <img
          src={`${baseAPIUrl}assets/images/unauthorized/unauthorized.png`}
          alt="Under construction illustration"
          className="unauthorized-image"
        />

        <h1 className="error-code">403</h1>
        <h2 className="error-title">Access Restricted</h2>

        <p className="error-message">
          Oops! The school page you're looking for doesn’t exist
          or the URL might be incorrect.
        </p>

        <div className="button-group">
          <Link to="/" className="primary-btn">
            Back to Home
          </Link>
          <Link to="/schools" className="secondary-btn">
            View All Schools
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Unauthorized;
